<div class="ol-popup" #highlightElement>
  <span class="title"></span>
</div>
